<template>
  <div class="detailWrapper">
    <TableToolTemp :toolListProps="{ toolTitle: '保全操作明细' }">
      <template #tips>
        <span>保全号：{{ info.endorsementNo }}</span>
        <span class="endorsementPremium" v-if="info.endorsementPremium != null&&info.endorsementPremium!='--'"
          >批单保费:{{ info.endorsementPremium }}</span
        >
        <span
          class="errspan"
          v-if="
            info.tripartitePreservationStatus &&
            (info.tripartitePreservationStatus == 'd' || info.tripartitePreservationStatus == 'f')
          "
          @click.prevent="viewsource(info)"
        >
          查看异常数据</span
        >
      </template>
    </TableToolTemp>
    <component :is="detailType" :preservationId="info.preservationId" :info='info'></component>
    <!-- <div class='goedit'>
      <el-button v-if="canEdit" type="primary" @click="goEdit">去编辑</el-button>
    </div> -->
  </div>
</template>
<script>
// 保全操作明细  分为 加保，减保 更换被保人 保险计划变更
import TableToolTemp from '@/components/layouts/TableToolTemp';
import { preservationpreservation, preservationgetPlan } from '@/api/securityManage';
import add from './add';
import cut from './cut';
import change from './change';
import changeplan from './changeplan';
export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    TableToolTemp,
    add,
    cut,
    change,
    changeplan,
  },
  watch: {
    // 'info.preservationType'(val){// preservationType, 01：加 02：减少 03：退保 04：更换 05：变更
    // debugger
    //   if(val=='01'){
    //     this.detailType='add'
    //   }else if(val=='02'){
    //     this.detailType='cut'
    //   }else if(val=='04'){
    //     this.detailType='change'
    //   }else if(val=='05'){
    //     this.detailType='changeplan'
    //   }
    // }
    'info.preservationType': {
      handler(val) {
        if (val == '01') {
          this.detailType = 'add';
        } else if (val == '02') {
          this.detailType = 'cut';
        } else if (val == '04') {
          this.detailType = 'change';
        } else if (val == '05') {
          this.detailType = 'changeplan';
        }
      },
      immediate:true
    },
  },
  data() {
    return {
      errPopupShow: false,
      errinfo: {},

      detailType: 'add', //cut,change,changeplan
      canEdit: false,
      planArr: [],
    };
  },
  methods: {
    viewsource(data) {
      this.$emit('showsource', data);
    },
    getcanEdit() {
      // 查询 保全明细是否可再编辑
      preservationpreservation({
        preservationId: this.info.preservationId,
      }).then((res) => {
        if (res && res.canEdit) {
          //可编辑
          this.canEdit = true;
        } else {
          this.canEdit = false;
        }
      });
    },
    goEdit() {
      //判断类型
      // preservationId,
      //   policyId,
      //   type,
      //   preservationType, 01：加 02：减少 03：退保 04：更换 05：变更
      let { preservationId, policyId, preservationType } = this.info;
      let path =
        preservationType == '01'
          ? '/addInsurer'
          : preservationType == '02'
          ? '/reduceInsurer'
          : preservationType == '04'
          ? '/insuredChange'
          : '/insuredChangePlan';
      let type = preservationType == '01' ? 1 : preservationType == '02' ? 2 : preservationType == '04' ? 3 : 4;

      this.$router.push({
        path: path,
        query: {
          preservationId,
          policyId,
          type,
          preservationType,
          from: 'history',
        },
      });
    },
    async getplan() {
      let res = await preservationgetPlan({ policyId: this.info.policyId });
      if (res) {
        //返回的是map，转为array
        for (let key in res) {
          this.planArr.push({
            planName: key,
            planId: res[key],
          });
        }
      }
    },
  },
  created() {
    this.getcanEdit();
    this.getplan();
  },
};
</script>
<style lang="less" scoped>
.errspan {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
  color: rgb(226, 124, 0);
}
.endorsementPremium {
  display: inline-block;
  margin-left: 20px;
}
.goedit {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>